import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";
// eslint-disable-next-line max-len
import { useTemplatesAndInstructionsMobile } from "./templatesAndInstructionsMobile/useTemplatesAndInstructionsMobile";
import { translate } from "@/config/translator";
import { Template } from "@/api/openapi";
import { Dispatch, SetStateAction } from "react";
import ListItemMobile from "@/components/listItemMobile/ListItemMobile";
import { faFile, faSearch } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type TemplatesAndInstructionsMobileProps = {
  templates: Template[] | undefined;
  onDownloadTemplate: (templateId: string) => void;
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
};

export function TemplatesAndInstructionsMobile({
  onDownloadTemplate,
  templates,
  searchQuery,
  setSearchQuery,
}: TemplatesAndInstructionsMobileProps) {
  const {
    lang,
    onBack,
    isSearching,
    setIsSearching,
    searchBoxRef,
    startSearchingMobile,
  } = useTemplatesAndInstructionsMobile();

  return (
    <>
      <TopBarMobile
        headerString={translate("templatesAndInstructions", lang)}
        onBack={onBack}
        onChangeSearch={setSearchQuery}
        searchValue={searchQuery}
        isSearching={isSearching}
        stopSearching={() => setIsSearching(false)}
        searchBoxRef={searchBoxRef}
        rightSide={
          <FontAwesomeIcon
            className="text-font-white text-2xl"
            icon={faSearch}
            onClick={startSearchingMobile}
          />
        }
      />

      <div className="p-6 overflow-y-auto">
        {(templates ?? Array.from({ length: 20 })).map(
          (template: Template | undefined) => (
            <ListItemMobile
              icon={faFile}
              onClick={
                template ? () => onDownloadTemplate(template.id) : undefined
              }
              primaryText={template?.title}
              secondaryText={
                template
                  ? translate(template.category ?? "generic", lang)
                  : undefined
              }
            />
          ),
        )}
      </div>
    </>
  );
}
